
import React, { useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Slider from 'react-slick'
import {Grid,
  Avatar,
  Card,
  IconButton,
  Tooltip,
  Typography, Box } from '@mui/material'
import { Close } from '@mui/icons-material'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'

// Centralized lodash imports - much cleaner!
import { map, slice, concat, compact, isEmpty } from '@/utils/lodash'

import {
  SLIDER_CONFIG,
  CARD_DIMENSIONS,
  AVATAR_POSITIONS,
  IMAGE_SOURCES,
} from '../constants'
import { useColorMode } from '@/theme/ColorModeProvider'

function stopCardNavigation(event) {
  event.preventDefault()
  event.stopPropagation()
}

function SliderArrowNext(props) {
  const { className, onClick } = props
  return (
    <div
      className={className}
      onClick={(event) => {
        stopCardNavigation(event)
        onClick?.(event)
      }}
    >
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  )
}

function SliderArrowPrev(props) {
  const { className, onClick } = props
  return (
    <div
      className={className}
      onClick={(event) => {
        stopCardNavigation(event)
        onClick?.(event)
      }}
    >
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  )
}

const PropertyCardImages = ({
  property,
  planImages,
  props,
  marketplaceOwned,
  owned,
  handleOpenCriticalFields,
  toggleHeart,
  heart,
  updateProperty,
  openPITICashData,
  setOpenPITICashData,
  openPITICreativeData,
  setOpenPITICreativeData,
}) => {
  const slider = useRef()
  const slider1 = useRef()
  const { resolvedMode } = useColorMode()
  const isDark = resolvedMode === 'dark'
  const actionAvatarSx = {
    backgroundColor: isDark ? 'rgba(30, 30, 30, 0.88)' : 'white',
    border: isDark
      ? '1px solid rgba(255, 255, 255, 0.22)'
      : '0.1px solid darkgray',
    color: isDark ? '#90caf9' : '#368cff',
    boxShadow: isDark ? '0 2px 8px rgba(0, 0, 0, 0.45)' : undefined,
  }
  const actionIconColor = isDark ? '#90caf9' : '#368cff'

  const [showImages, setShowImages] = useState(false)
  const [images, setImages] = useState([])

  const widgetsCarousels1B = {
    ...SLIDER_CONFIG,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
  }

  const toggleImages =
    (images = []) =>
    (event) => {
      event.stopPropagation()
      setShowImages(!showImages)
      setImages(images)
    }

  const renderPropertySearchImages = () => {
    if (
      !props.propertySearch ||
      property.marketplaces ||
      !property.images
    ) {
      return null
    }

    // Only allow valid http/https string URLs
    const stringImages = compact(
      map(slice(property.images, 0, 5), (img) =>
        typeof img === 'string' && /^https?:\/\//.test(img)
          ? img
          : null,
      ),
    )

    return map(stringImages, (image) => (
      <div key={image}>
        <Card
          style={{
            height: CARD_DIMENSIONS.IMAGE_HEIGHT,
            backgroundColor: 'white',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            margin: 1,
          }}
          onClick={toggleImages(property.images)}
          sx={{ boxShadow: 'none' }}
        >
          <Grid
            container
            direction="column"
            style={{ height: '100%' }}
            sx={{
              justifyContent: 'center',
            }}
          >
            <Grid>
              <Box onClick={(event) => { if (props.marketplace && !marketplaceOwned) { event.preventDefault() } else { event.preventDefault(); handleOpenCriticalFields() } }} style={{ textAlign: 'center', backgroundColor: 'transparent', borderBottomRightRadius: '0px', }} sx={{
                position: "relative",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                "& .img-wrapper-overlay": {
                  width: "100%",
                  height: "100%",
                  transition: "all 0.2s ease-in-out",
                  opacity: 0,
                  visibility: "hidden",
                  position: "absolute",
                  left: 0,
                  top: 0,
                  boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                  display: "flex",
                  alignItems: "center",
                  alignContent: "center",
                  color: "#fff",
                  borderTopLeftRadius: "inherit",
                  borderTopRightRadius: "inherit",
                  "@media (max-width: 575.98px)": {
                    "& + img": { width: "100% !important" },
                  },
                  "& .overlay-btn-wrapper": {
                    position: "relative",
                    zIndex: 3,
                    textAlign: "center",
                    width: "100%",
                  },
                  "&::before": {
                    zIndex: 2,
                    position: "absolute",
                    left: 0,
                    top: 0,
                    content: "\"\"",
                    width: "100%",
                    height: "100%",
                    transition: "all 0.2s ease-in-out",
                    background: "#000",
                    opacity: 0.75,
                  },
                },
                "& .img-wrapper-overlay--visible": {
                  visibility: "visible",
                  opacity: 1,
                  position: "relative",
                  zIndex: 5,
                },
                "& .card-badges": { zIndex: 5 },
                "a&": {
                  display: "block",
                  overflow: "hidden",
                  "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                },
              }}>
                <Box
                  component="img"
                  src={image}
                  style={{ objectFit: 'contain' }}
                  alt="..."
                  onError={(e) => {
                    e.currentTarget.style.display = 'none'
                  }}
                  sx={{ flexShrink: 0, width: "100%" }}
                />
              </Box>
            </Grid>
          </Grid>
        </Card>
      </div>
    ))
  }

  const renderPlaceholderImage = () => (
    <div key="placeholder">
      <Card
        style={{
          height: CARD_DIMENSIONS.IMAGE_HEIGHT,
          backgroundColor: 'white',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          margin: 1,
        }}
        sx={{ boxShadow: 'none' }}
      >
        <Grid
          container
          direction="column"
          style={{ height: '100%' }}
          sx={{
            justifyContent: 'center',
          }}
        >
          <Grid>
            <Box style={{ textAlign: 'center', backgroundColor: 'transparent', borderBottomRightRadius: '0px', }} sx={{
              position: "relative",
              borderTopLeftRadius: "inherit",
              borderTopRightRadius: "inherit",
              "& .img-wrapper-overlay": {
                width: "100%",
                height: "100%",
                transition: "all 0.2s ease-in-out",
                opacity: 0,
                visibility: "hidden",
                position: "absolute",
                left: 0,
                top: 0,
                boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                color: "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                "@media (max-width: 575.98px)": {
                  "& + img": { width: "100% !important" },
                },
                "& .overlay-btn-wrapper": {
                  position: "relative",
                  zIndex: 3,
                  textAlign: "center",
                  width: "100%",
                },
                "&::before": {
                  zIndex: 2,
                  position: "absolute",
                  left: 0,
                  top: 0,
                  content: "\"\"",
                  width: "100%",
                  height: "100%",
                  transition: "all 0.2s ease-in-out",
                  background: "#000",
                  opacity: 0.75,
                },
              },
              "& .img-wrapper-overlay--visible": {
                visibility: "visible",
                opacity: 1,
                position: "relative",
                zIndex: 5,
              },
              "& .card-badges": { zIndex: 5 },
              "a&": {
                display: "block",
                overflow: "hidden",
                "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
              },
            }}>
              <Box component="img" src={IMAGE_SOURCES.DEFAULT} style={{ objectFit: 'contain', maxHeight: CARD_DIMENSIONS.IMAGE_HEIGHT, width: '100%', height: CARD_DIMENSIONS.IMAGE_HEIGHT, }} alt="No property image" sx={{ flexShrink: 0, width: "100%" }} />
            </Box>
          </Grid>
        </Grid>
      </Card>
    </div>
  )

  const renderPropertyImages = () => {
    const allImages = compact(concat(property.images, planImages))

    // Exclude string URLs (used by propertySearch) and only keep objects
    const objectImages = compact(
      map(allImages, (img) =>
        typeof img === 'object' && (img.url || img.url_small)
          ? img
          : null,
      ),
    )

    if (isEmpty(objectImages)) {
      return renderPlaceholderImage()
    }

    return map(slice(objectImages, 0, 5), (image) => (
      <div key={image.url || image.url_small}>
        <Card
          style={{
            height: CARD_DIMENSIONS.IMAGE_HEIGHT,
            backgroundColor: 'white',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            margin: 1,
          }}
          sx={{ boxShadow: 'none' }}
        >
          <Grid
            container
            direction="column"
            style={{ height: '100%' }}
            sx={{
              justifyContent: 'center',
            }}
          >
            <Grid>
              <Box onClick={(event) => { if ( (props.marketplace && !marketplaceOwned) || props.trash ) { event.preventDefault() } else { event.preventDefault(); handleOpenCriticalFields() } }} style={{ textAlign: 'center', backgroundColor: 'transparent', borderBottomRightRadius: '0px', }} sx={{
                position: "relative",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                "& .img-wrapper-overlay": {
                  width: "100%",
                  height: "100%",
                  transition: "all 0.2s ease-in-out",
                  opacity: 0,
                  visibility: "hidden",
                  position: "absolute",
                  left: 0,
                  top: 0,
                  boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                  display: "flex",
                  alignItems: "center",
                  alignContent: "center",
                  color: "#fff",
                  borderTopLeftRadius: "inherit",
                  borderTopRightRadius: "inherit",
                  "@media (max-width: 575.98px)": {
                    "& + img": { width: "100% !important" },
                  },
                  "& .overlay-btn-wrapper": {
                    position: "relative",
                    zIndex: 3,
                    textAlign: "center",
                    width: "100%",
                  },
                  "&::before": {
                    zIndex: 2,
                    position: "absolute",
                    left: 0,
                    top: 0,
                    content: "\"\"",
                    width: "100%",
                    height: "100%",
                    transition: "all 0.2s ease-in-out",
                    background: "#000",
                    opacity: 0.75,
                  },
                },
                "& .img-wrapper-overlay--visible": {
                  visibility: "visible",
                  opacity: 1,
                  position: "relative",
                  zIndex: 5,
                },
                "& .card-badges": { zIndex: 5 },
                "a&": {
                  display: "block",
                  overflow: "hidden",
                  "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                },
              }}>
                <Box style={{ backgroundImage: `url(${image.url_small })`, height: CARD_DIMENSIONS.IMAGE_HEIGHT, display: 'flex', justifyContent: 'center', alignItems: 'center', }} sx={{ backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                  <Box component="img" src={image.url} style={{ objectFit: 'contain', maxHeight: CARD_DIMENSIONS.IMAGE_HEIGHT, }} alt="..." loading="lazy" onError={(e) => {
                    e.currentTarget.onerror = null
                    e.currentTarget.src = IMAGE_SOURCES.DEFAULT
                    e.currentTarget.style.display = ''
                  }} sx={{ flexShrink: 0, width: "100%" }} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </div>
    ))
  }

  return (
    <>
      <Slider ref={slider} {...widgetsCarousels1B} style={{ height: CARD_DIMENSIONS.IMAGE_HEIGHT, overflow: 'hidden', marginBottom: 0 }} sx={{ flexShrink: 0, width: "100%" }}>
        {renderPropertySearchImages()}
        {renderPropertyImages()}
      </Slider>

      {/* Action Buttons */}
      {!props.marketplace && !props.shared && (
        <Avatar sx={{ position: 'absolute', left: AVATAR_POSITIONS.HEART_LEFT, top: AVATAR_POSITIONS.HEART_TOP, ...actionAvatarSx, }} onClick={(event) => { event.stopPropagation(); event.preventDefault(); toggleHeart() }} data-hf="action-avatar">
          <FontAwesomeIcon icon={[heart ? 'fas' : 'fal', 'heart']} style={{ color: actionIconColor }} sx={[{ display: 'block' }, { fontSize: "1.265rem !important" }]} />
        </Avatar>
      )}

      <Avatar sx={{ position: 'absolute', left: !props.marketplace && !props.shared ? AVATAR_POSITIONS.EXTERNAL_LEFT_OFFSET : AVATAR_POSITIONS.MARKETPLACE_LEFT, top: AVATAR_POSITIONS.HEART_TOP, ...actionAvatarSx, }} onClick={(event) => { event.stopPropagation(); event.preventDefault(); window.open( `/property-details/${property._id}/Summary`, '_blank', )
        }} data-hf="action-avatar">
        <FontAwesomeIcon icon={['fas', 'arrow-up-right-from-square']} style={{ color: actionIconColor }} sx={[{ display: 'block' }, { fontSize: "1.265rem !important" }]} />
      </Avatar>

      {/* Marketplace Icons */}
      {marketplaceOwned &&
        property.marketplaces &&
        !isEmpty(property.marketplaces.approvedMarketplace) && (
          <Tooltip
            title={
              <Grid container direction="column">
                {map(
                  property.marketplaces.approvedMarketplace,
                  (marketplace) => (
                    <Grid key={marketplace}>
                      <Typography
                        style={
                          marketplace === 'housefolios' &&
                          new Date(
                            property.marketplaces.expirationDate,
                          ).getTime() < Date.now()
                            ? { color: 'red' }
                            : null
                        }
                      >
                        {marketplace}
                      </Typography>
                    </Grid>
                  ),
                )}
              </Grid>
            }
          >
            <Avatar
              style={{
                position: 'absolute',
                right: AVATAR_POSITIONS.MARKETPLACE_ICON_RIGHT,
                top: AVATAR_POSITIONS.MARKETPLACE_ICON_TOP,
                backgroundColor: '#28b854',
                border: '0.1px solid white',
              }}
            >
              <FontAwesomeIcon icon={['fas', 'sign-hanging']} style={{ display: 'block' }} sx={{ fontSize: "1.265rem !important" }} />
            </Avatar>
          </Tooltip>
        )}

      {/* Image Dialog */}
      <Dialog
        open={showImages}
        onClose={toggleImages()}
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle>
          <IconButton
            onClick={toggleImages()}
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
            }}
            size="large"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Slider ref={slider1} {...widgetsCarousels1B} sx={[{ flexShrink: 0, width: "100%" }, {
            "& .slick-dots li button": { background: "rgba(255, 255, 255, 0.3)" },
            "& .slick-dots li.slick-active button": { background: "white" },
          }]}>
            {!isEmpty(images) ? (
              map(images, (image) => (
                <div key={image.url}>
                  <Card
                    style={{
                      height: CARD_DIMENSIONS.IMAGE_HEIGHT,
                      backgroundColor: 'black',
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0,
                    }}
                    sx={{ boxShadow: 'none' }}
                  >
                    <Grid
                      container
                      direction="column"
                      style={{ height: '100%' }}
                      sx={{
                        justifyContent: 'center',
                      }}
                    >
                      <Grid>
                        <Box style={{ textAlign: 'center', backgroundColor: 'transparent', borderBottomRightRadius: '0px', }} sx={{
                          position: "relative",
                          borderTopLeftRadius: "inherit",
                          borderTopRightRadius: "inherit",
                          "& .img-wrapper-overlay": {
                            width: "100%",
                            height: "100%",
                            transition: "all 0.2s ease-in-out",
                            opacity: 0,
                            visibility: "hidden",
                            position: "absolute",
                            left: 0,
                            top: 0,
                            boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                            display: "flex",
                            alignItems: "center",
                            alignContent: "center",
                            color: "#fff",
                            borderTopLeftRadius: "inherit",
                            borderTopRightRadius: "inherit",
                            "@media (max-width: 575.98px)": {
                              "& + img": { width: "100% !important" },
                            },
                            "& .overlay-btn-wrapper": {
                              position: "relative",
                              zIndex: 3,
                              textAlign: "center",
                              width: "100%",
                            },
                            "&::before": {
                              zIndex: 2,
                              position: "absolute",
                              left: 0,
                              top: 0,
                              content: "\"\"",
                              width: "100%",
                              height: "100%",
                              transition: "all 0.2s ease-in-out",
                              background: "#000",
                              opacity: 0.75,
                            },
                          },
                          "& .img-wrapper-overlay--visible": {
                            visibility: "visible",
                            opacity: 1,
                            position: "relative",
                            zIndex: 5,
                          },
                          "& .card-badges": { zIndex: 5 },
                          "a&": {
                            display: "block",
                            overflow: "hidden",
                            "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                          },
                        }}>
                          <Box style={{ backgroundImage: `url(${image.url_small })`, height: CARD_DIMENSIONS.IMAGE_HEIGHT, display: 'flex', justifyContent: 'center', alignItems: 'center', }} sx={{ backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                            <Box component="img" src={image.url} style={{ maxHeight: CARD_DIMENSIONS.IMAGE_HEIGHT, height: 'auto', width: 'auto', objectFit: 'contain', }} alt="..." loading="lazy" sx={{ flexShrink: 0, width: "100%" }} />
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </div>
              ))
            ) : (
              <div>
                <Card
                  style={{
                    height: CARD_DIMENSIONS.IMAGE_HEIGHT,
                    backgroundColor: 'black',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                  }}
                  sx={{ boxShadow: 'none' }}
                >
                  <Grid
                    container
                    direction="column"
                    style={{ height: '100%' }}
                    sx={{
                      justifyContent: 'center',
                    }}
                  >
                    <Grid>
                      <Box style={{ textAlign: 'center', backgroundColor: 'transparent', }} sx={{
                        position: "relative",
                        borderTopLeftRadius: "inherit",
                        borderTopRightRadius: "inherit",
                        "& .img-wrapper-overlay": {
                          width: "100%",
                          height: "100%",
                          transition: "all 0.2s ease-in-out",
                          opacity: 0,
                          visibility: "hidden",
                          position: "absolute",
                          left: 0,
                          top: 0,
                          boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                          display: "flex",
                          alignItems: "center",
                          alignContent: "center",
                          color: "#fff",
                          borderTopLeftRadius: "inherit",
                          borderTopRightRadius: "inherit",
                          "@media (max-width: 575.98px)": {
                            "& + img": { width: "100% !important" },
                          },
                          "& .overlay-btn-wrapper": {
                            position: "relative",
                            zIndex: 3,
                            textAlign: "center",
                            width: "100%",
                          },
                          "&::before": {
                            zIndex: 2,
                            position: "absolute",
                            left: 0,
                            top: 0,
                            content: "\"\"",
                            width: "100%",
                            height: "100%",
                            transition: "all 0.2s ease-in-out",
                            background: "#000",
                            opacity: 0.75,
                          },
                        },
                        "& .img-wrapper-overlay--visible": {
                          visibility: "visible",
                          opacity: 1,
                          position: "relative",
                          zIndex: 5,
                        },
                        "& .card-badges": { zIndex: 5 },
                        "a&": {
                          display: "block",
                          overflow: "hidden",
                          "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                        },
                      }}>
                        <Box component="img" src={IMAGE_SOURCES.DEFAULT} style={{ maxHeight: CARD_DIMENSIONS.IMAGE_HEIGHT, height: 'auto', width: 'auto', objectFit: 'contain', }} alt="..." sx={{ flexShrink: 0, width: "100%" }} />
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </div>
            )}
          </Slider>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default PropertyCardImages
